import(/* webpackMode: "eager" */ "/codebuild/output/src2708694347/src/apps/fanychance/src/app/error.tsx");
